<!-- 月度手卫生报告 -->
<template>
  <div class='hospitalStatistics' style='background-color:#fff;padding:40px 12px 15px;' :style='{"max-width":reportData.isWeb==1?"1200px":"","min-width":reportData.isWeb==1?"1000px":"","margin":reportData.isWeb==1?"0 auto":""}'>
    <div class="hospitalStatistics-content">
      <div class="report-title">
        <div>{{source==1?'**医院':reportData.contentObj.CONTENT0}}</div>
        <div>{{reportData.contentObj.CONTENT24}}</div>
      </div>
      <div class="report-tips-oblique" v-if='reportData.isWeb!=1'> 【建议下载本文档后在电脑端查看】 </div>
      <div class="report-introduction">手卫生主要是针对医务人员在工作中存在的交叉感染的风险而采取的措施，是医院感染控制的重要手段，是医院常规监测十三项指标之一。通过手卫生，可以有效降低医院感染。为促进医疗机构手卫生监测工作，经研究并报国家卫生健康委医政司同意，全国医疗机构感染监测网组织开展{{reportData.batch}}年度全国医疗机构医务人员诊疗过程手卫生调查。
      </div>
      <div class="report-introduction" style="margin-top:5px;">【目的】监测医疗机构重点部门手卫生依从率；监测医疗机构重点部门手卫生用品日消耗量；建立医务人员诊疗过程手卫生监测数据的评价体系；对比医院感染发病率、医院感染现患率、多重耐药菌检出率、导尿管相关泌尿道感染发病率、血管导管相关血流感染发病率和呼吸机相关肺炎发病率等，并评价其与手卫生相关性；促进手卫生的持续改进。
      </div>
      <div class="report-introduction" style="margin-top:5px;">【方法】{{reportData.contentObj.CONTENT1}} - {{reportData.contentObj.CONTENT2}}采用手卫生观察员现场调查方法获取{{reportData.contentObj.CONTENT13}}医疗和护理手卫生执行情况、手术部(室)手术医生外科手消毒执行情况，并统计同期调查科室工作量、手卫生用品消耗量以及医疗机构实际开放床位数，计算手卫生依从率和手卫生用品床日消耗量/人次消耗量。
      </div>
      <div class="report-introduction" style="margin-top:5px;">【结果】</div>
      <div class="report-introduction" v-if='reportData.contentObj.CONTENT25_1'> {{reportData.contentObj.CONTENT25_1}} </div>
      <div class="report-introduction" v-if='reportData.contentObj.CONTENT25_2'> {{reportData.contentObj.CONTENT25_2}} </div>
      <div class="report-introduction" v-if='reportData.contentObj.CONTENT25_3'> {{reportData.contentObj.CONTENT25_3}} </div>
      <div class="report-introduction" v-if='reportData.contentObj.CONTENT25_4'> {{reportData.contentObj.CONTENT25_4}} </div>
      <div class="report-introduction" v-if='reportData.CONTENT26'> {{reportData.CONTENT26}} </div>
      <div class="report-introduction" v-if='!reportData.contentObj.CONTENT25_1&&!reportData.contentObj.CONTENT25_2&&!reportData.contentObj.CONTENT25_3&&!reportData.contentObj.CONTENT25_4&&!reportData.CONTENT26'>暂无数据</div>
      <div class="report-introduction" style="margin-top:5px;">本院的基本情况：{{reportData.contentObj.CONTENT26}} </div>
      <div class="report-content">
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-1'>1. 手卫生知识知晓率情况 </div>
        <div class="bold" id='hps-1.1'>1.1 手卫生学习任务完成情况</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj.CONTENT4'> 本次学习共{{reportData.contentObj.CONTENT3}}个单元参与，参与人数{{reportData.contentObj.CONTENT4}}，完成人数{{reportData.contentObj.CONTENT5}}，完成率{{reportData.contentObj.CONTENT6}}%，平均阅读时长为{{reportData.contentObj.CONTENT7}}分钟。</div>
        <div class='surface-description'>表1-1 各单元的学习任务学习完成情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>单元</th>
              <th>临床科室分类</th>
              <th>院区</th>
              <th>参与人数</th>
              <th>未完成人数</th>
              <th>完成人数</th>
              <th>完成率</th>
            </tr>
          </thead>
          <template v-if="reportData.tableOneData.length>0">
            <tr
              v-for="(item,index) in reportData.tableOneData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.WARD_NAME!=null?item.WARD_NAME:'-'}}</td>
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.HC_NAME!=null?item.HC_NAME:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_NUM2!=null?item.USER_NUM2:'-'}}</td>
              <td>{{item.USER_NUM3!=null?item.USER_NUM3:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='7'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表1-2 单个学习任务的学习完成情况</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>学习任务</th>
              <th>参与人数</th>
              <th>未完成人数</th>
              <th>完成人数</th>
              <th>完成率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwoData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableTwoData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.TASK_ORDER!=null?item.TASK_ORDER:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_NUM2!=null?item.USER_NUM2:'-'}}</td>
              <td>{{item.USER_NUM3!=null?item.USER_NUM3:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='5'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表1-3 各单元的学习完成情况</div>
        <div class='surface-description'>（完成率=该单元的单个任务完成人数/该单元的参与人数*100%）</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th rowspan='2'>单元</th>
              <th rowspan='2'>参与人数</th>
              <th :colspan="reportData.tableTwoData.length">完成率</th>
            </tr>
            <tr>
              <th v-for="(item,index) in reportData.tableTwoData" :key="index">{{item.TASK_ORDER}}</th>
            </tr>
          </thead>
          <template v-if='reportData.tableThreeData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableThreeData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.WARD_NAME!=null?item.WARD_NAME:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td v-for="(d,idx) in reportData.tableTwoData" :key="idx">{{item['TASK_NUM' + (idx+1)]!=null?item['TASK_NUM' + (idx+1)] + "%":'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                :colspan='reportData.tableTwoData.length + 2'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class="bold" style='margin-top:10px' id='hps-1.2'>1.2 手卫生考试情况</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj.CONTENT9'> 本院参与考试共{{reportData.contentObj.CONTENT8}}个单元、参与人数{{reportData.contentObj.CONTENT9}}、平均分{{reportData.contentObj.CONTENT10}}、标准差{{reportData.contentObj.CONTENT11}}、合格率{{reportData.contentObj.CONTENT12}}% </div>
        <div class='surface-description'>表1-4 不同成绩区间分布 （平均成绩区间分布）</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>成绩区间（分）</th>
              <th>人数</th>
              <th>占比</th>
            </tr>
          </thead>
          <template v-if='reportData.tableFourData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableFourData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.EXAM_SCORE!=null?item.EXAM_SCORE:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='3'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div
          id="echarts1"
          :class='{"web-echarts-heightFixed":reportData.isWeb==1}' :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}'
          v-if="reportData.echartsOneData.length>0&&reportData.contentObj.CONTENT9"
        ></div>
        <!-- <div v-else>暂无数据</div> -->
        <div class='surface-description'>表1-5 各单元的考试合格情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>单元</th>
              <th>临床科室分类</th>
              <th>院区</th>
              <th>参与人数</th>
              <th>平均分</th>
              <th>标准差</th>
              <th>合格率</th>
            </tr>
          </thead>
          <template v-if="reportData.tableFiveData.length>0">
            <tr
              v-for="(item,index) in reportData.tableFiveData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.WARD_NAME!=null?item.WARD_NAME:'-'}}</td>
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.HC_NAME!=null?item.HC_NAME:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.AVG_SCORE!=null?item.AVG_SCORE:'-'}}</td>
              <td>{{item.STD_SCORE!=null?item.STD_SCORE:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='7'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表1-6 题目的答题正确及错误情况</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>错误率排名</th>
              <th>题目</th>
              <th>答题人次</th>
              <th>正确人次</th>
              <th>错误人次</th>
              <th>错误率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableSixData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableSixData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td :colspan="index == reportData.tableSixData.length-1?2:1">{{item.RANK_NO!=null?item.RANK_NO:'-'}}</td>
              <td v-if='index != reportData.tableSixData.length-1'>{{item.BIZ_ORDER!=null?item.BIZ_ORDER:'-'}}</td>
              <td>{{item.ANSWER_CNT!=null?item.ANSWER_CNT:'-'}}</td>
              <td>{{item.ANSWER_OK_CNT!=null?item.ANSWER_OK_CNT:'-'}}</td>
              <td>{{item.ANSWER_ERROR_CNT!=null?item.ANSWER_ERROR_CNT:'-'}}</td>
              <td>{{item.ERROR_RATE!=null?item.ERROR_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>

        <div class="bold" style='margin-top:10px' id='hps-1.3'>1.3 手卫生证书获得情况</div>
        <div class='surface-description'>表1-7 获得证书情况</div>
        <div class='surface-description'>（获得证书占比=该单元已获得证书人数/该单元的参与人数*100%）</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>单元</th>
              <th>临床科室分类</th>
              <th>院区</th>
              <th>参与人数</th>
              <th>未完成人数</th>
              <th>已获得证书人数</th>
              <th>获得证书占比</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSevenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableSevenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.WARD_NAME!=null?item.WARD_NAME:'-'}}</td>
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.HC_NAME!=null?item.HC_NAME:'-'}}</td>
              <td>{{item.USER_NUM1!=null?item.USER_NUM1:'-'}}</td>
              <td>{{item.USER_NUM2!=null?item.USER_NUM2:'-'}}</td>
              <td>{{item.USER_NUM3!=null?item.USER_NUM3:'-'}}</td>
              <td>{{item.USER_RATE!=null?item.USER_RATE+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='7'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>

        <div class="twoLevel-title" style='margin-top:10px;' id='hps-2'>2. 调查科室手卫生依从及正确执行情况 </div>
        <div class="bold" id='hps-2.1'>2.1 调查科室洗手/卫生手消毒依从及正确执行情况</div>
        <div class="bold" style='margin-top:10px;' id='hps-2.1.1'>2.1.1 本次调查洗手/卫生手消毒时机依从率/正确率</div>
        <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.contentObj.CONTENT16'> 本次调查共观察到{{reportData.contentObj.CONTENT13}}病区单元工作人员包括医疗、护理，调查手卫生时机{{reportData.contentObj.CONTENT14}}次，实施手卫生次数{{reportData.contentObj.CONTENT15}}次，正确次数{{reportData.contentObj.CONTENT16}}次，依从率{{reportData.contentObj.CONTENT17}}%，正确率{{reportData.contentObj.CONTENT18}}%。 </div>
        <div class='surface-description'>表2-1 洗手/卫生手消毒依从执行率/正确率（%）（依从率{{reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget}}%以下标红，正确率{{reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget}}%以下标红）</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
            <thead>
              <tr>
                <th>督查类型</th>
                <th>时机数</th>
                <th>执行次数</th>
                <th>观察人数</th>
                <th>依从率</th>
                <th>正确数</th>
                <th>正确率</th>
              </tr>
            </thead>
            <template v-if="reportData.tableEightData.length>0">
              <tr
                v-for="(item,index) in reportData.tableEightData"
                :key='index'
                :style="{'background-color':index%2!=0?'#f1eff1':''}"
              >
                <td>{{item.CHECK_TYPE!=null?item.CHECK_TYPE:'-'}}</td>
                <td>{{item.SJS!=null?item.SJS:'-'}}</td>
                <td>{{item.YCS!=null?item.YCS:'-'}}</td>
                <td>{{item.USER_CNT!=null?item.USER_CNT:'-'}}</td>
                <td :style="{'color':(item.YCL&&item.YCL<parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.YCL==0?'red':''}">{{item.YCL!=null?item.YCL+'%':'-'}}</td>
                <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
                <td :style="{'color':(item.ZQL&&item.ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null?item.ZQL+'%':'-'}}</td>
              </tr>
            </template>
            <template v-else>
              <tr> <td colspan='7' style="width:100%;text-align:center;" >暂无数据</td> </tr>
            </template>
        </table>
        <div class="bold" style='margin-top:10px' id='hps-2.1.2'>2.1.2 不同指征洗手/卫生手消毒时机依从率/正确率</div>
        <div class='surface-description'>表2-2 {{reportData.contentObj.CONTENT23_1}}不同指征洗手/卫生手消毒依从及正确执行情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>指征</th>
              <th>应执行次数</th>
              <th>执行次数</th>
              <th>正确执行次数</th>
              <th>依从率（ %）</th>
              <th>正确率（%）</th>
            </tr>
          </thead>
          <template v-if="reportData.tableNineData.length>0">
            <tr
              v-for="(item,index) in reportData.tableNineData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.INDICATION_NAME!=null?item.INDICATION_NAME:'-'}}</td>
              <td>{{item.SJS!=null?item.SJS:'-'}}</td>
              <td>{{item.YCS!=null?item.YCS:'-'}}</td>
              <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
              <td :style="{'color':(item.YCL&&item.YCL<parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.YCL==0?'red':''}">{{item.YCL!=null?item.YCL+'%':'-'}}</td>
              <td :style="{'color':(item.ZQL&&item.ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null?item.ZQL+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>图2-2 指征依从性、正确率</div>
        <div
          id="echarts2"
          :class='{"web-echarts-heightFixed":reportData.isWeb==1}' :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}'
          v-if="reportData.echartsTwoData.length>0&&reportData.contentObj.CONTENT14"
        ></div>
        <div v-else>暂无数据</div>
        <div
          class="bold"
          style='margin-top:10px'
          id='hps-2.1.3'
        >2.1.3. 不同岗位人员洗手/卫生手消毒时机依从率/正确率</div>
        <div class='surface-description'>表2-3 洗手/卫生手消毒岗位时机依从率与正确率</div>
        <table class="mergeRowTable mergeRowTableCenter" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>岗位</th>
              <th>岗位性质</th>
              <th>观察人数</th>
              <th>时机数</th>
              <th>执行次数</th>
              <th>依从率</th>
              <th>正确数</th>
              <th>正确率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTenData.length>0'>
            <tbody
              v-for="(item,index) in reportData.tableTenData"
              :key='index'
              :style="{'background-color':index%2==0?'#fff':'#f1eff1'}"
            >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem' >{{item.WORK_NAME!=null?item.WORK_NAME:'-'}}</td>
                <td class='childRenItem' >{{item.dataInfo[0].NATURE_NAME!=null?item.dataInfo[0].NATURE_NAME:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].USER_CNT!=null?item.dataInfo[0].USER_CNT:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].SJS!=null?item.dataInfo[0].SJS:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].YCS!=null?item.dataInfo[0].YCS:'-'}}</td>
                <td class='childRenItem' :style="{'color':(item.dataInfo[0].YCL&&item.dataInfo[0].YCL<parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.dataInfo[0].YCL==0?'red':''}">{{item.dataInfo[0].YCL!=null&&item.dataInfo[0].YCL!='-'?item.dataInfo[0].YCL+'%':'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].ZQS!=null?item.dataInfo[0].ZQS:'-'}}</td>
                <td class='childRenItem' :style="{'color':(item.dataInfo[0].ZQL&&item.dataInfo[0].ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.dataInfo[0].ZQL==0?'red':''}">{{item.dataInfo[0].ZQL!=null&&item.dataInfo[0].ZQL!='-'?item.dataInfo[0].ZQL+'%':'-'}}</td>
              </tr>
              <tr v-for="(d,idx) in item.dataInfo" v-if='idx>0' :key='idx' >
                <td class='childRenItem'>{{d.NATURE_NAME!=null?d.NATURE_NAME:'-'}}</td>
                <td class='childRenItem'>{{d.USER_CNT!=null?d.USER_CNT:'-'}}</td>
                <td class='childRenItem'>{{d.SJS!=null?d.SJS:'-'}}</td>
                <td class='childRenItem'>{{d.YCS!=null?d.YCS:'-'}}</td>
                <td class='childRenItem' :style="{'color':(d.YCL&&d.YCL<parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||d.YCL==0?'red':''}">{{d.YCL!=null&&d.YCL!='-'?d.YCL+'%':'-'}}</td>
                <td class='childRenItem'>{{d.ZQS!=null?d.ZQS:'-'}}</td>
                <td class='childRenItem' :style="{'color':(d.ZQL&&d.ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||d.ZQL==0?'red':''}">{{d.ZQL!=null&&d.ZQL!='-'?d.ZQL+'%':'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr>
                <td
                  colspan='8'
                  style="width:100%;"
                >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div class='surface-description'>图2-3 洗手/卫生手消毒岗位依从率与正确率对比图</div>
        <div
          id="echarts3"
          :class='{"web-echarts-heightFixed":reportData.isWeb==1}' :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}'
          v-if="reportData.echartsThreeData.length>0"
        ></div>
        <div v-else>暂无数据</div>
        <div class="bold" style='margin-top:10px' id='hps-2.1.4'>2.1.4. 不同岗位人员指征依从率/正确率</div>
        <div class='surface-description'>表2-4 洗手/卫生手消毒岗位指征依从率、正确率</div>
        <table
          class="mergeRowTable mergeRowTableCenter mergeRowTableNotBorder"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>指征</th>
              <th>分类</th>
              <th>护理</th>
              <th>医疗</th>
              <th>医技</th>
              <th>工勤</th>
              <th>其他</th>
              <th>行政管理</th>
              <th>合计</th>
            </tr>
          </thead>
          <template v-if='reportData.tableElevenData.length>0'>
            <tbody
              v-for="(item,index) in reportData.tableElevenData"
              :key='index'
              :style="{'background-color':index%2==0?'#fff':'#f1eff1'}"
            >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem' >{{item.INDICATION_NAME!=null?item.INDICATION_NAME:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].TASK_TYPE!=null?item.dataInfo[0].TASK_TYPE:'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_1!=null&&item.dataInfo[0].RATE_1!='-'?item.dataInfo[0].RATE_1+'%':'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_2!=null&&item.dataInfo[0].RATE_2!='-'?item.dataInfo[0].RATE_2+'%':'-'}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_3}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_4}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_5}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].RATE_6}}</td>
                <td class='childRenItem'>{{item.dataInfo[0].POST_RATE!=null?item.dataInfo[0].POST_RATE+'%':'-'}}</td>
              </tr>
              <tr
                v-for="(d,idx) in item.dataInfo"
                v-if='idx>0&&item.dataInfo.length>1'
                :key='idx'
              >
                <td class='childRenItem'>{{d.TASK_TYPE!=null?d.TASK_TYPE:'-'}}</td>
                <td class='childRenItem'>{{d.RATE_1!=null&&d.RATE_1!='-'?d.RATE_1+'%':'-'}}</td>
                <td class='childRenItem'>{{d.RATE_2!=null&&d.RATE_2!='-'?d.RATE_2+'%':'-'}}</td>
                <td class='childRenItem'>{{d.RATE_3}}</td>
                <td class='childRenItem'>{{d.RATE_4}}</td>
                <td class='childRenItem'>{{d.RATE_5}}</td>
                <td class='childRenItem'>{{d.RATE_6}}</td>
                <td class='childRenItem'>{{d.POST_RATE!=null?d.POST_RATE+'%':'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr>
                <td
                  colspan='9'
                  style="width:100%;text-align:center;"
                >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div class='surface-description'>图2-4 洗手/卫生手消毒被观察岗位构成比</div>
        <div
          id="echarts4"
          :class='{"web-echarts-heightFixed":reportData.isWeb==1}' :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}'
          v-if="reportData.echartsFourData.length>0"
        ></div>
        <div v-else>暂无数据</div>
        <div
          class="bold"
          style='margin-top:10px'
          id='hps-2.1.5'
        >2.1.5 不同实施方式依从率与正确率</div>
        <div class='surface-description'>表2-5 不同实施方式正确率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>类别</th>
              <th>次数</th>
              <th>构成比</th>
              <th>正确数</th>
              <th>正确率</th>
            </tr>
          </thead>
          <template v-if='reportData.tableTwelveData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableTwelveData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.TASK_TYPE!=null?item.TASK_TYPE:'-'}}</td>
              <td>{{item.YCS!=null?item.YCS:'-'}}</td>
              <td>{{item.YCS_RATE!=null?item.YCS_RATE+'%':'-'}}</td>
              <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
              <td :style="{'color':(item.ZQL&&item.ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null?item.ZQL+'%':'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='5'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>图2-5 洗手/卫生手消毒方式构成分布图</div>
        <div
          id="echarts5"
          :class='{"web-echarts-heightFixed":reportData.isWeb==1}' :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}'
          v-if="reportData.echartsFiveData.length>0"
        ></div>
        <div v-else>暂无数据</div>
        <div
          class="bold"
          style='margin-top:10px'
          id='hps-2.1.6'
        >2.1.6. 单元洗手/卫生手消毒平均依从率/正确率以及管理目标值达标情况</div>
        <!-- <div class="report-paragraph  report-paragraph-lh25">与目标值对比：{{reportData.contentObj.CONTENT19}}个单元依从率达标，{{reportData.contentObj.CONTENT20}}个单元依从率不达标，{{reportData.contentObj.CONTENT21}}个单元正确率达标，{{reportData.contentObj.CONTENT22}}个单元正确率不达标。</div> -->
        <div class="report-paragraph  report-paragraph-lh25">{{reportData.handStr}}</div>
        <div class='surface-description'>表2-6 各单元洗手/卫生手消毒依从率及正确率、目标值达标评估</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>序号</th>
              <th>单元</th>
              <th style='width: 12%;'>临床科室分类</th>
              <th style='width: 12%;'>院区</th>
              <th>时机数</th>
              <th>执行次数</th>
              <th>依从率≥{{reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget}}%</th>
              <th>正确数</th>
              <th>正确率≥{{reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget}}%</th>
              <th colspan='2'>达标评估与得分</th>
            </tr>
          </thead>
          <template v-if='reportData.tableThirteenData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableThirteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.RANK_NO!=null?item.RANK_NO:'-'}}</td>
              <td>{{item.WARD_NAME!=null?item.WARD_NAME:'-'}}</td>
              <td>{{item.DEPT_NAME!=null?item.DEPT_NAME:'-'}}</td>
              <td>{{item.HC_NAME!=null?item.HC_NAME:'-'}}</td>
              <td>{{item.SJS!=null?item.SJS:'-'}}</td>
              <td>{{item.YCS!=null?item.YCS:'-'}}</td>
              <td :style="{'color':(item.YCL&&item.YCL < parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.YCL==0?'red':''}">{{item.YCL!=null&&item.YCL!='--'?item.YCL+'%':'--'}}</td>
              <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
              <td :style="{'color':(item.ZQL&&item.ZQL < parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null&&item.ZQL!='--'?item.ZQL+'%':'--'}}</td>
              <!-- <td>{{item.EVALUATE!=null?item.EVALUATE:'-'}}</td>
              <td>{{item.SCORE!=null?item.SCORE:'-'}}</td> -->
              <td>{{(item.YCL&&item.YCL < parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget)) || (item.ZQL&&item.ZQL < parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))?'未达标':'--'}}</td>
              <td>{{(item.YCL&&item.YCL < parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget)) || (item.ZQL&&item.ZQL < parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))?'扣2分':'--'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表2-7 调查科室洗手/卫生手消毒依从率及正确率、目标值达标评估</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>序号</th>
              <th>调查科室</th>
              <th>时机数</th>
              <th>执行次数</th>
              <th>依从率≥{{reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget}}%</th>
              <th>正确数</th>
              <th>正确率≥{{reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget}}%</th>
              <th colspan='2'>达标评估与得分</th>
            </tr>
          </thead>
          <template v-if='reportData.tableFourteenData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableFourteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.RANK_NO!=null?item.RANK_NO:'-'}}</td>
              <td>{{item.DEPT_STANDARD_NAME!=null?item.DEPT_STANDARD_NAME:'-'}}</td>
              <td>{{item.SJS!=null?item.SJS:'-'}}</td>
              <td>{{item.YCS!=null?item.YCS:'-'}}</td>
              <td :style="{'color':(item.YCL&&item.YCL < parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.YCL==0?'red':''}">{{item.YCL!=null&&item.YCL!='--'?item.YCL+'%':'--'}}</td>
              <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
              <td :style="{'color':(item.ZQL&&item.ZQL < parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null&&item.ZQL!='--'?item.ZQL+'%':'--'}}</td>
              <!-- <td>{{item.EVALUATE!=null?item.EVALUATE:'-'}}</td>
              <td>{{item.SCORE!=null?item.SCORE:'-'}}</td> -->
              <td>{{(item.YCL&&item.YCL < parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget)) || (item.ZQL&&item.ZQL < parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))?'未达标':'--'}}</td>
              <td>{{(item.YCL&&item.YCL < parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget)) || (item.ZQL&&item.ZQL < parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))?'扣2分':'--'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='9'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div v-if='reportData.CONTENT27'>
          <div class="bold" style='margin-top:10px;' id='hps-2.2'>2.2 外科手消毒依从及正确执行情况</div>
          <div class="bold" style='margin-top:10px;' id='hps-2.2.1'>2.2.1 本次调查外科手消毒依从率/正确率</div>
          <div class="report-paragraph  report-paragraph-lh25" v-if='reportData.CONTENT27'> {{reportData.CONTENT27}} </div>
          <div class='surface-description'>表2-8 外科手消毒依从执行率/正确率（%）（依从率{{reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget}}%以下标红，正确率{{reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget}}%以下标红）</div>
          <table class="table" border="0" cellspacing="0" cellpadding="0" >
              <thead>
                <tr>
                  <th>督查类型</th>
                  <th>时机数</th>
                  <th>外科手消毒次数</th>
                  <th>观察人数</th>
                  <th>依从率</th>
                  <th>正确数</th>
                  <th>正确率</th>
                </tr>
              </thead>
              <template v-if="reportData.tableTwentyOneData.length>0">
                <tr
                  v-for="(item,index) in reportData.tableTwentyOneData"
                  :key='index'
                  :style="{'background-color':index%2!=0?'#f1eff1':''}"
                >
                  <td>{{item.CHECK_TYPE!=null?item.CHECK_TYPE:'-'}}</td>
                  <td>{{item.SJS!=null?item.SJS:'-'}}</td>
                  <td>{{item.YCS!=null?item.YCS:'-'}}</td>
                  <td>{{item.USER_CNT!=null?item.USER_CNT:'-'}}</td>
                  <td :style="{'color':(item.YCL&&item.YCL<parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.YCL==0?'red':''}">{{item.YCL!=null?item.YCL+'%':'-'}}</td>
                  <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
                  <td :style="{'color':(item.ZQL&&item.ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null?item.ZQL+'%':'-'}}</td>
                </tr>
              </template>
              <template v-else>
                <tr> <td colspan='7' style="width:100%;text-align:center;" >暂无数据</td> </tr>
              </template>
          </table>
          <div class="bold" style='margin-top:10px;' id='hps-2.2.2'>2.2.2 不同指征外科手消毒依从率/正确率</div>
          <div class='surface-description'>表2-9 {{reportData.contentObj.CONTENT23_1}}不同指征外科手消毒依从及正确执行情况</div>
          <table
            class="table"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <thead>
              <tr>
                <th>指征</th>
                <th>应执行次数</th>
                <th>执行次数</th>
                <th>正确执行次数</th>
                <th>依从率（ %）</th>
                <th>正确率（%）</th>
              </tr>
            </thead>
            <template v-if="reportData.tableTwentyTwoData.length>0">
              <tr
                v-for="(item,index) in reportData.tableTwentyTwoData"
                :key='index'
                :style="{'background-color':index%2!=0?'#f1eff1':''}"
              >
                <td>{{item.INDICATION_NAME!=null?item.INDICATION_NAME:'-'}}</td>
                <td>{{item.SJS!=null?item.SJS:'-'}}</td>
                <td>{{item.YCS!=null?item.YCS:'-'}}</td>
                <td>{{item.ZQS!=null?item.ZQS:'-'}}</td>
                <td :style="{'color':(item.YCL&&item.YCL<parseInt(reportData.handComplianceTarget?reportData.handComplianceTarget:$route.query.handComplianceTarget))||item.YCL==0?'red':''}">{{item.YCL!=null?item.YCL+'%':'-'}}</td>
                <td :style="{'color':(item.ZQL&&item.ZQL<parseInt(reportData.handCorrectionTarget?reportData.handCorrectionTarget:$route.query.handCorrectionTarget))||item.ZQL==0?'red':''}">{{item.ZQL!=null?item.ZQL+'%':'-'}}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  colspan='6'
                  style="width:100%;"
                >暂无数据</td>
              </tr>
            </template>
          </table>
          <div class='surface-description'>图2-6 指征依从性、正确率</div>
          <div
            id="echarts2_6"
            :class='{"web-echarts-heightFixed":reportData.isWeb==1}' :style='{"margin-top":reportData.isWeb==1?"80px":"20px"}'
            v-if="reportData.echartsTwo2Data.length>0"
          ></div>
          <div v-else>暂无数据</div>
        </div>

        <div class="twoLevel-title" style='margin-top:10px;' id='hps-3'>3. 调查科室手卫生用品消耗情况</div>
        <div class="hps-3-box" v-if='reportData.tableSeventeenData.length>1||reportData.tableEighteenData.length>0||reportData.tableNineteenData.length>0||reportData.tableNineteen_4Data.length>0'>
        <div class="bold" id='hps-3.1'>3.1 手卫生用品消耗情况</div>
        <div class="report-paragraph  report-paragraph-lh25">{{reportData.contentObj.CONTENT27}}</div>
        <div class='surface-description'>表3-1 {{reportData.contentObj.CONTENT23}}不同科室每床日手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>实际开放床位数</th>
              <th>住院床日数</th>
              <th>手卫生用品消耗量(mL)</th>
              <th>消耗量(mL/床日)</th>
              <th>手卫生次数(次/床日)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableSeventeenData.length>1">
            <tr
              v-for="(item,index) in reportData.tableSeventeenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_STANDARD_NAME!=null?item.DEPT_STANDARD_NAME:'-'}}</td>
              <td>{{item.OPEN_BEDS!=null?item.OPEN_BEDS:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME!=null?item.CONSUME:'-'}}</td>
              <td>{{item.CONSUME_BEDS!=null?item.CONSUME_BEDS:'-'}}</td>
              <td>{{item.CONSUME_BEDS2!=null?item.CONSUME_BEDS2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='6'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：按照每次手卫生取用量2.5mL折算手卫生次数）</div>
        <div class='surface-description'>表3-2 {{reportData.contentObj.CONTENT23}}儿科门急诊和血液透析室每人次(患者)手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>患者人次</th>
              <th>手卫生用品消耗量(mL)</th>
              <th>消耗量(mL/人次)</th>
              <th>手卫生次数(次/人次)</th>
            </tr>
          </thead>
          <template v-if="reportData.tableEighteenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableEighteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_STANDARD_NAME!=null?item.DEPT_STANDARD_NAME:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.CONSUME!=null?item.CONSUME:'-'}}</td>
              <td>{{item.CONSUME_BEDS!=null?item.CONSUME_BEDS:'-'}}</td>
              <td>{{item.CONSUME_BEDS2!=null?item.CONSUME_BEDS2:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='5'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：按照每次手卫生取用量2.5mL折算手卫生次数）</div>
        <div class='surface-description'>表3-3 {{reportData.contentObj.CONTENT23}}血液透析室每人次(患者)手套消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>患者人次</th>
              <th>手套消耗总量（双）</th>
              <th>手套（双/人次）</th>
            </tr>
          </thead>
          <template v-if="reportData.tableNineteenData.length>0">
            <tr
              v-for="(item,index) in reportData.tableNineteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_STANDARD_NAME!=null?item.DEPT_STANDARD_NAME:'-'}}</td>
              <td>{{item.BEDS!=null?item.BEDS:'-'}}</td>
              <td>{{item.GOLVES!=null?item.GOLVES:'-'}}</td>
              <td>{{item.GOLVES_BEDS!=null?item.GOLVES_BEDS:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='4'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description'>表3-4 {{reportData.contentObj.CONTENT23}}手术部（室）每台次手术手卫生用品消耗情况</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th>科室</th>
              <th>手术台次</th>
              <th>手卫生用品消耗量（mL）</th>
              <th>消耗量（mL/台次）</th>
            </tr>
          </thead>
          <template v-if="reportData.tableNineteen_4Data.length>0">
            <tr
              v-for="(item,index) in reportData.tableNineteen_4Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.DEPT_STANDARD_NAME!=null?item.DEPT_STANDARD_NAME:'-'}}</td>
              <td>{{item.CONSUME_RATE!=null?item.CONSUME_RATE:'-'}}</td>
              <td>{{item.CONSUME!=null?item.CONSUME:'-'}}</td>
              <td>{{item.OPEN_BEDS!=null?item.OPEN_BEDS:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='4'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div v-if="reportData.contentObj008.HAS_DATA == '1'">
          <div class="bold" style='margin-top:10px' id='hps-3.2'>3.2 手卫生用品消耗情况</div>
          <div class="report-paragraph  report-paragraph-lh25">{{reportData.contentObj008.CONTENT}}</div>
          <div class='surface-description'>表3-5 {{parseInt(reportData.batch)}}年手卫生用品抽检合格率情况</div>
          <table
            class="table"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <thead>
              <tr>
                <th>抽检整体合格率（%）</th>
                <th>卫生手洗手液合格率（%）</th>
                <th>外科手洗手液合格率（%）</th>
                <th>卫生手快速手消毒液合格率（%）</th>
                <th>外科手快速手消毒液合格率（%）</th>
              </tr>
            </thead>
            <template v-if="reportData.tableTwentyThreeData.length>0">
              <tr
                v-for="(item,index) in reportData.tableTwentyThreeData"
                :key='index'
                :style="{'background-color':index%2!=0?'#f1eff1':''}"
              >
                <td>{{item.TOTAL_RATE!=null?item.TOTAL_RATE+'%':'-'}}</td>
                <td>{{item.RATE1!=null?item.RATE1+'%':'-'}}</td>
                <td>{{item.RATE2!=null?item.RATE2+'%':'-'}}</td>
                <td>{{item.RATE3!=null?item.RATE3+'%':'-'}}</td>
                <td>{{item.RATE4!=null?item.RATE4+'%':'-'}}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  colspan='5'
                  style="width:100%;"
                >暂无数据</td>
              </tr>
            </template>
          </table>
        </div>
        </div>
        <div v-else>未上报数据</div>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-4'>4. 重点质控指标情况</div>
        <div class='surface-description' v-if='reportData.tableTwentyData.length>0'>表4-1 {{parseInt(reportData.batch-1)}}年重点质控指标</div>
        <table
          class="mergeRowTable mergeRowTableCenter mergeRowTableNotBorder"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <template v-if='reportData.tableTwentyData.length>0'>
            <tbody
              v-for="(item,index) in reportData.tableTwentyData"
              :key='index'
              :style="{'background-color':index%2==0?'#f1eff1':''}"
            >
              <tr v-if='item.dataInfo.length>0'>
                <td :style="{'border-top':index==0?'1px solid #dfdfdf':'','border-top-left-radius':index==0?'10px':''}" :rowspan='item.dataInfo.length' class='childRenItem'>{{item.INDEX_NAME!=null?item.INDEX_NAME:'-'}}</td>
                <td :style="{'border-top':index==0?'1px solid #dfdfdf':''}" class='childRenItem'>{{item.dataInfo[0].OPTION_NAME!=null?item.dataInfo[0].OPTION_NAME:'-'}}</td>
                <td :style="{'border-top':index==0?'1px solid #dfdfdf':'','border-top-right-radius':index==0?'10px':''}" class='childRenItem'>{{item.dataInfo[0].OPTION_VALUE!=null?item.dataInfo[0].OPTION_VALUE:'-'}}</td>
              </tr>
              <tr
                v-for="(d,idx) in item.dataInfo"
                v-if='idx>0&&item.dataInfo.length>1'
                :key='idx'
              >
                <td class='childRenItem'>{{d.OPTION_NAME!=null?d.OPTION_NAME:'-'}}</td>
                <td class='childRenItem'>{{d.OPTION_VALUE!=null?d.OPTION_VALUE:'-'}}</td>
              </tr>
            </tbody>
          </template>
          <!-- <template v-else>
            <tbody>
              <tr>
                <td
                  colspan='3'
                  style="width:100%;text-align:center;"
                >暂无数据</td>
              </tr>
            </tbody>
          </template> -->
        </table>
        <div v-if='!reportData.tableTwentyData.length'>未上报数据</div>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-5'>5. 管理提示</div>
        <div class="bold" id='hps-5.1'>5.1 手卫生依从率与同类医院比较</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT510!=null'>
        <div class="" > 本院手卫生依从率：{{reportData.CONTENT510}}% </div>
        <div class="" > 全国参与本次活动的同级别、同类型、同规模的医院数为{{reportData.CONTENT511}}家，时机数{{reportData.CONTENT513}}，手卫生次数{{reportData.CONTENT514}}，依从率为{{reportData.CONTENT512}}%
          <div v-if='reportData.CONTENT511>=55' style='display:inline;'>，其手卫生依从率百分位分布如下：</div> </div>
        <div class="table-box" v-if='reportData.CONTENT511>=55'>
        <div class='surface-description'>表5-1 相同医院的手卫生依从率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">相同医院的手卫生依从率百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep511Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep511Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep511Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT511>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <!-- 如果相同医院数量>=55家时的管理提示   手卫生依从率和相同医院的手卫生依从率百分位分布比较-->
        <!-- 如果相同医院数量<55家时的管理提示    手卫生依从率和相同医院的平均值进行比较-->
        <div class="tipsBox" v-if='reportData.CONTENT511>=55&&reportData.CONTENT510>reportData.tablep511Data[0].P75'>
          <div class="" > ①手卫生依从率在全国同级别、同类型、同规模医院中属于较高水平。 </div>
          <div class="" > ②本院手卫生管理模式优于大多数医院。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT511>=55&&reportData.CONTENT510>reportData.tablep511Data[0].P50&&reportData.CONTENT510<=reportData.tablep511Data[0].P75)||(reportData.CONTENT511<55&&reportData.CONTENT510>=reportData.CONTENT512)'>
          <div class="" > ①手卫生依从率在全国同级别、同类型、同规模医院中属于中上水平。 </div>
          <div class="" > ②本院手卫生管理模式优于多数医院，还需持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT511>=55&&reportData.CONTENT510>reportData.tablep511Data[0].P25&&reportData.CONTENT510<=reportData.tablep511Data[0].P50)||(reportData.CONTENT511<55&&reportData.CONTENT510<reportData.CONTENT512)'>
          <div class="" > ①手卫生依从率在全国同级别、同类型、同规模医院中属于中下水平。 </div>
          <div class="" > ②本院手卫生管理模式比多数医院差，还需持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT511>=55&&reportData.CONTENT510<=reportData.tablep511Data[0].P25'>
          <div class="" > ①手卫生依从率在全国同级别、同类型、同规模医院中属于较低水平。 </div>
          <div class="" > ②本院手卫生管理模式比大多数医院差，还需持续改进。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>


        <div class="bold" style='margin-top:10px;' id='hps-5.2'>5.2 手卫生知识知晓率对依从率的影响</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT520!=null'>
        <div class="" > 本院手卫生知识知晓率：{{reportData.CONTENT520}}% </div>
        <div class="" > 全国参与本次活动的同级别、同类型、同规模、相同手卫生知识知晓率（{{reportData.CONTENT525}}%-{{reportData.CONTENT526}}%）的医院数为{{reportData.CONTENT521}}家
          <div v-if='reportData.CONTENT521' style='display:inline;'>，时机数{{reportData.CONTENT523}}，手卫生次数{{reportData.CONTENT524}}，依从率为{{reportData.CONTENT522}}%</div>
          <div v-if='reportData.CONTENT521>=55' style='display:inline;'>，其手卫生依从率百分位分布如下：</div></div>
        <div class="table-box" v-if='reportData.CONTENT521>=55'>
        <div class='surface-description'>表5-2 相同医院、相同手卫生知晓率医院的手卫生依从率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">相同医院、相同手卫生知晓率手卫生依从率百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep521Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep521Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep521Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT521>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT521>=55&&reportData.CONTENT520>reportData.tablep521Data[0].P75'>
          <div class="" > ①关注数据的准确性，避免调查过程中产生霍桑效应。 </div>
          <div class="" > ②手卫生依从率在相同医院、手卫生知识知晓率同水平医院中属于较高水平。 </div>
          <div class="" > ③关注提高医院人员手卫生知识培训，提高知晓率，可以提升医务人员手卫生依从率。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT521>=55&&reportData.CONTENT520>reportData.tablep521Data[0].P50&&reportData.CONTENT520<=reportData.tablep521Data[0].P75)||(reportData.CONTENT521<55&&reportData.CONTENT520>=reportData.CONTENT522)'>
          <div class="" > ①关注数据的准确性，避免调查过程中产生霍桑效应。 </div>
          <div class="" > ②手卫生依从率在相同医院、手卫生知识知晓率同水平医院中属于中上水平。 </div>
          <div class="" > ③关注提高医院人员手卫生知识培训，提高知晓率，可以提升医务人员手卫生依从率。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT521>=55&&reportData.CONTENT520>reportData.tablep521Data[0].P25&&reportData.CONTENT520<=reportData.tablep521Data[0].P50)||(reportData.CONTENT521<55&&reportData.CONTENT520<reportData.CONTENT522)'>
          <div class="" > ①手卫生依从率在相同医院、手卫生知识知晓率同水平医院中属于中下水平。 </div>
          <div class="" > ②关注提高医院人员手卫生知识培训，提高知晓率，可以提升医务人员手卫生依从率。 </div>
          <div class="" > ③查找影响本院手卫生依从率处于相同情况医院中较低水平的原因，在提升医务人员手卫生知晓率的同时改进其他核心影响因素。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT521>=55&&reportData.CONTENT520<=reportData.tablep521Data[0].P25'>
          <div class="" > ①手卫生依从率在相同医院、手卫生知识知晓率同水平医院中属于较低水平。 </div>
          <div class="" > ②关注提高医院人员手卫生知识培训，提高知晓率，可以提升医务人员手卫生依从率。 </div>
          <div class="" > ③查找影响本院手卫生依从率处于相同情况医院中较低水平的原因，在提升医务人员手卫生知晓率的同时改进其他核心影响因素。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>




        <div class="bold" style='margin-top:10px;' id='hps-5.3'>5.3 手卫生用品消耗量与手卫生依从率的关系</div>
        <div class="bold" style='margin-top:10px;' id='hps-5.3.1'>5.3.1 综合ICU</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5310!=null'>
        <div class="" > 本院综合ICU手卫生用品的消耗量指标为：{{reportData.CONTENT5310}} mL/床日，按照每次手卫生取用量2.5mL折算，本院综合ICU手卫生次数为{{reportData.CONTENT5313}}次/床日。 </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模医院，综合ICU相同手卫生依从率水平（{{reportData.CONTENT5314}}%~{{reportData.CONTENT5315}}%）的医院数为{{reportData.CONTENT5311}}家，实际开放床位数{{reportData.CONTENT5316}}，科室住院床日数{{reportData.CONTENT5317}}，科室手卫生用品消耗量{{reportData.CONTENT5318}}mL，消耗量{{reportData.CONTENT5312}}mL/床日
          <div v-if='reportData.CONTENT5311>=55' style='display:inline;'>，其手卫生用品消耗量百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5311>=55'>
        <div class='surface-description'>表5-3-1 相同医院、相同手卫生依从率水平医院【综合ICU】手卫生用品消耗量</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">综合ICU手卫生用品消耗量百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5311Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5311Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5311Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5311>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5311>=55&&reportData.CONTENT5310>reportData.tablep5311Data[0].P75'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较高水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5311>=55&&reportData.CONTENT5310>reportData.tablep5311Data[0].P50&&reportData.CONTENT5310<=reportData.tablep5311Data[0].P75)||(reportData.CONTENT5311<55&&reportData.CONTENT5310>=reportData.CONTENT5312)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于中等水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5311>=55&&reportData.CONTENT5310>reportData.tablep5311Data[0].P25&&reportData.CONTENT5310<=reportData.tablep5311Data[0].P50)||(reportData.CONTENT5311<55&&reportData.CONTENT5310<reportData.CONTENT5312)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较低水平。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5311>=55&&reportData.CONTENT5310<=reportData.tablep5311Data[0].P25'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量过低。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.3.2'>5.3.2 呼吸科(组)</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5320!=null'>
        <div class="" >
          本院呼吸科(组)手卫生用品的消耗量指标为：{{reportData.CONTENT5320}} mL/床日，按照每次手卫生取用量2.5mL折算，本院呼吸科(组)手卫生次数为{{reportData.CONTENT5323}}次/床日。 
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模医院，呼吸科(组)相同手卫生依从率水平（{{reportData.CONTENT5324}}%~{{reportData.CONTENT5325}}%）的医院数为{{reportData.CONTENT5321}}家，实际开放床位数{{reportData.CONTENT5326}}，科室住院床日数{{reportData.CONTENT5327}}，科室手卫生用品消耗量{{reportData.CONTENT5328}}mL，消耗量{{reportData.CONTENT5322}}mL/床日
          <div v-if='reportData.CONTENT5321>=55' style='display:inline;'>，其手卫生用品消耗量百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5321>=55'>
        <div class='surface-description'>表5-3-2 相同医院、相同手卫生依从率水平医院【呼吸科(组)】手卫生用品消耗量</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">呼吸科(组)手卫生用品消耗量百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5321Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5321Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5321Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5321>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5321>=55&&reportData.CONTENT5320>reportData.tablep5321Data[0].P75'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较高水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5321>=55&&reportData.CONTENT5320>reportData.tablep5321Data[0].P50&&reportData.CONTENT5320<=reportData.tablep5321Data[0].P75)||(reportData.CONTENT5321<55&&reportData.CONTENT5320>=reportData.CONTENT5322)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于中等水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5321>=55&&reportData.CONTENT5320>reportData.tablep5321Data[0].P25&&reportData.CONTENT5320<=reportData.tablep5321Data[0].P50)||(reportData.CONTENT5321<55&&reportData.CONTENT5320<reportData.CONTENT5322)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较低水平。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5321>=55&&reportData.CONTENT5320<=reportData.tablep5321Data[0].P25'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量过低。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.3.3'>5.3.3 骨科</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5330!=null'>
        <div class="" >
          本院骨科手卫生用品的消耗量指标为：{{reportData.CONTENT5330}} mL/床日，按照每次手卫生取用量2.5mL折算，本院骨科手卫生次数为{{reportData.CONTENT5333}}次/床日。
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模医院，骨科相同手卫生依从率水平（{{reportData.CONTENT5334}}%~{{reportData.CONTENT5335}}%）的医院数为{{reportData.CONTENT5331}}家，实际开放床位数{{reportData.CONTENT5336}}，科室住院床日数{{reportData.CONTENT5337}}，科室手卫生用品消耗量{{reportData.CONTENT5338}}mL，消耗量{{reportData.CONTENT5332}}mL/床日
          <div v-if='reportData.CONTENT5331>=55' style='display:inline;'>，其手卫生用品消耗量百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5331>=55'>
        <div class='surface-description'>表5-3-3 相同医院、相同手卫生依从率水平医院【骨科】手卫生用品消耗量</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">骨科手卫生用品消耗量百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5331Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5331Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5331Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5331>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5331>=55&&reportData.CONTENT5330>reportData.tablep5331Data[0].P75'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较高水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5331>=55&&reportData.CONTENT5330>reportData.tablep5331Data[0].P50&&reportData.CONTENT5330<=reportData.tablep5331Data[0].P75)||(reportData.CONTENT5331<55&&reportData.CONTENT5330>=reportData.CONTENT5332)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于中等水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5331>=55&&reportData.CONTENT5330>reportData.tablep5331Data[0].P25&&reportData.CONTENT5330<=reportData.tablep5331Data[0].P50)||(reportData.CONTENT5331<55&&reportData.CONTENT5330<reportData.CONTENT5332)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较低水平。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5331>=55&&reportData.CONTENT5330<=reportData.tablep5331Data[0].P25'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量过低。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.3.4'>5.3.4 感染病科(组)</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5340!=null'>
        <div class="" >
          本院感染病科(组)手卫生用品的消耗量指标为：{{reportData.CONTENT5340}} mL/床日，按照每次手卫生取用量2.5mL折算，本院感染病科(组)手卫生次数为{{reportData.CONTENT5343}}次/床日。
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模医院，感染病科(组)相同手卫生依从率水平（{{reportData.CONTENT5344}}%~{{reportData.CONTENT5345}}%）的医院数为{{reportData.CONTENT5341}}家，实际开放床位数{{reportData.CONTENT5346}}，科室住院床日数{{reportData.CONTENT5347}}，科室手卫生用品消耗量{{reportData.CONTENT5348}}mL，消耗量{{reportData.CONTENT5342}}mL/床日
          <div v-if='reportData.CONTENT5341>=55' style='display:inline;'>，其手卫生用品消耗量百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5341>=55'>
        <div class='surface-description'>表5-3-4 相同医院、相同手卫生依从率水平医院【感染病科(组)】手卫生用品消耗量</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">感染病科(组)手卫生用品消耗量百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5341Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5341Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5341Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5341>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5341>=55&&reportData.CONTENT5340>reportData.tablep5341Data[0].P75'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较高水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5341>=55&&reportData.CONTENT5340>reportData.tablep5341Data[0].P50&&reportData.CONTENT5340<=reportData.tablep5341Data[0].P75)||(reportData.CONTENT5341<55&&reportData.CONTENT5340>=reportData.CONTENT5342)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于中等水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5341>=55&&reportData.CONTENT5340>reportData.tablep5341Data[0].P25&&reportData.CONTENT5340<=reportData.tablep5341Data[0].P50)||(reportData.CONTENT5341<55&&reportData.CONTENT5340<reportData.CONTENT5342)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较低水平。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5341>=55&&reportData.CONTENT5340<=reportData.tablep5341Data[0].P25'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量过低。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.3.5'>5.3.5 儿科门急诊</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5350!=null'>
        <div class="" >
          本院儿科门急诊手卫生用品的消耗量指标为：{{reportData.CONTENT5350}} mL/人次，按照每次手卫生取用量2.5mL折算，本院儿科门急诊手卫生次数为{{reportData.CONTENT5353}}次/人次。
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模医院，儿科门急诊相同手卫生依从率水平（{{reportData.CONTENT5354}}%~{{reportData.CONTENT5355}}%）的医院数为{{reportData.CONTENT5351}}家，儿科门急诊日门诊量{{reportData.CONTENT5356}}，儿科门急诊人次{{reportData.CONTENT5357}}，科室手卫生用品消耗量{{reportData.CONTENT5358}}mL，消耗量{{reportData.CONTENT5352}}mL/人次
          <div v-if='reportData.CONTENT5351>=55' style='display:inline;'>，其手卫生用品消耗量百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5351>=55'>
        <div class='surface-description'>表5-3-5 相同医院、相同手卫生依从率水平医院【儿科门急诊】手卫生用品消耗量</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">儿科门急诊手卫生用品消耗量百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5351Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5351Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5351Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5351>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5351>=55&&reportData.CONTENT5350>reportData.tablep5351Data[0].P75'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较高水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5351>=55&&reportData.CONTENT5350>reportData.tablep5351Data[0].P50&&reportData.CONTENT5350<=reportData.tablep5351Data[0].P75)||(reportData.CONTENT5351<55&&reportData.CONTENT5350>=reportData.CONTENT5352)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于中等水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5351>=55&&reportData.CONTENT5350>reportData.tablep5351Data[0].P25&&reportData.CONTENT5350<=reportData.tablep5351Data[0].P50)||(reportData.CONTENT5351<55&&reportData.CONTENT5350<reportData.CONTENT5352)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较低水平。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5351>=55&&reportData.CONTENT5350<=reportData.tablep5351Data[0].P25'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量过低。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.3.6'>5.3.6 血液透析室</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5360!=null'>
        <div class="" >
          本院血液透析室手卫生用品的消耗量指标为：{{reportData.CONTENT5360}} mL/人次，按照每次手卫生取用量2.5mL折算，本院血液透析室手卫生次数为{{reportData.CONTENT5363}}次/人次。
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模医院，血液透析室相同手卫生依从率水平（{{reportData.CONTENT5364}}%~{{reportData.CONTENT5365}}%）的医院数为{{reportData.CONTENT5361}}家，血液透析人数{{reportData.CONTENT5366}}，血液透析室人次{{reportData.CONTENT5367}}，科室手卫生用品消耗量{{reportData.CONTENT5368}}mL，消耗量{{reportData.CONTENT5362}}mL/人次
          <div v-if='reportData.CONTENT5361>=55' style='display:inline;'>，其手卫生用品消耗量百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5361>=55'>
        <div class='surface-description'>表5-3-6 相同医院、相同手卫生依从率水平医院【血液透析室】手卫生用品消耗量</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">血液透析室手卫生用品消耗量百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5361Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5361Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5361Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5361>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5361>=55&&reportData.CONTENT5360>reportData.tablep5361Data[0].P75'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较高水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5361>=55&&reportData.CONTENT5360>reportData.tablep5361Data[0].P50&&reportData.CONTENT5360<=reportData.tablep5361Data[0].P75)||(reportData.CONTENT5361<55&&reportData.CONTENT5360>=reportData.CONTENT5362)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于中等水平。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5361>=55&&reportData.CONTENT5360>reportData.tablep5361Data[0].P25&&reportData.CONTENT5360<=reportData.tablep5361Data[0].P50)||(reportData.CONTENT5361<55&&reportData.CONTENT5360<reportData.CONTENT5362)'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量处于较低水平。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5361>=55&&reportData.CONTENT5360<=reportData.tablep5361Data[0].P25'>
          <div class="" > ①与相同医院相同手卫生依从率医院比较，手卫生用品消耗量过低。 </div>
          <div class="" > ②手卫生依从率与手卫生用品消耗量可能存在不符合情况，请关注手卫生依从率数据准确性。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>



        <div class="bold" style='margin-top:10px;' id='hps-5.4'>5.4 手卫生依从率对感染率的影响</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT540!=null'>
        <div class="" > 本院的感染率为：{{reportData.CONTENT540}}% </div>
        <div class="" > 
          全国参与本次活动的同级别、同类型、同规模，相同手卫生依从率水平（{{reportData.CONTENT543}}%~{{reportData.CONTENT544}}%）医院的医院数为{{reportData.CONTENT541}}家，同期新发医院病例数{{reportData.CONTENT545}}，全年出院人数{{reportData.CONTENT546}}，年末在院患者人数{{reportData.CONTENT547}}，医院感染发病率{{reportData.CONTENT542}}%
          <div v-if='reportData.CONTENT541>=55' style='display:inline;'>。其医院感染率百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT541>=55'>
        <div class='surface-description'>表5-4 相同医院、相同手卫生依从率水平医院感染率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">相同医院、相同手卫生依从率水平医院感染率百分位分布（%）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep541Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep541Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep541Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT541>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT541>=55&&reportData.CONTENT540>reportData.tablep541Data[0].P75'>
          <div class="" > ①关注数据的准确性； </div>
          <div class="" > ②本院感染率在手卫生管理水平相当的相同医院中高于75%的医院，应引起重视； </div>
          <div class="" > ③探索对本院医院感染发病率产生了负效应的其它因素，应针对其进行持续改进； </div>
          <div class="" > ④本院的管理模式有待提升。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT541>=55&&reportData.CONTENT540>reportData.tablep541Data[0].P50&&reportData.CONTENT540<=reportData.tablep541Data[0].P75)||(reportData.CONTENT541<55&&reportData.CONTENT540>=reportData.CONTENT542)'>
          <div class="" > ①关注数据的准确性； </div>
          <div class="" > ②本院感染率在手卫生管理水平相当的相同医院中高于50%的医院，应引起重视； </div>
          <div class="" > ③探索对本院医院感染发病率产生了负效应的其它因素，应针对其进行持续改进； </div>
          <div class="" > ④本院的管理模式有待提升。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT541>=55&&reportData.CONTENT540>reportData.tablep541Data[0].P25&&reportData.CONTENT540<=reportData.tablep541Data[0].P50)||(reportData.CONTENT541<55&&reportData.CONTENT540<reportData.CONTENT542)'>
          <div class="" > ①关注数据的准确性； </div>
          <div class="" > ②本院感染率在手卫生管理水平相当的相同医院中低于50%的医院； </div>
          <div class="" > ③是否有其它影响医院感染发病率的因素，产生了重大的协同作用（正效应）； </div>
          <div class="" > ④本院的管理模式优于多数医院。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT541>=55&&reportData.CONTENT540<=reportData.tablep541Data[0].P25'>
          <div class="" > ①关注数据的准确性； </div>
          <div class="" > ②本院感染率在手卫生管理水平相当的同类医院中低于75%的医院； </div>
          <div class="" > ③是否有其它影响医院感染发病率的因素，产生了重大的协同作用（正效应）； </div>
          <div class="" > ④本院的管理模式优于多数医院。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>



        <div class="bold" style='margin-top:10px;' id='hps-5.5'>5.5 综合ICU三管的感染率与同级别医院的比较</div>
        <div class="bold" style='margin-top:10px;' id='hps-5.5.1'>5.5.1 综合ICU血管导管相关血流感染发病率</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5510!=null'>
        <div class="" > 
          本院综合ICU血管导管相关血流感染发病率为：{{reportData.CONTENT5510}}‰
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模的医院数为{{reportData.CONTENT5511}}家，同期中央血管导管留置总天数{{reportData.CONTENT5513}}，同期新发导管相关血流感染例次数{{reportData.CONTENT5514}}，发病率{{reportData.CONTENT5512}}‰
          <div v-if='reportData.CONTENT5511>=55' style='display:inline;'>。其百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5511>=55'>
        <div class='surface-description'>表5-5-1 相同医院综合ICU血管导管相关血流感染发病率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">血管导管相关血流感染发病率百分位分布（‰）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5511Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5511Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5511Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5511>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5511>=55&&reportData.CONTENT5510>reportData.tablep5511Data[0].P75'>
          <div class="" > ①本院综合ICU血管导管相关血流感染发病率高于75%的同级别、同类型、同规模医院。 </div>
          <div class="" > ②关注影响综合ICU血管导管相关血流感染发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5511>=55&&reportData.CONTENT5510>reportData.tablep5511Data[0].P50&&reportData.CONTENT5510<=reportData.tablep5511Data[0].P75)||(reportData.CONTENT5511<55&&reportData.CONTENT5510>=reportData.CONTENT5512)'>
          <div class="" > ①本院综合ICU血管导管相关血流感染发病率与同级别、同类型、同规模医院比较，高于50%的医院，在较高发病率水平。 </div>
          <div class="" > ②关注影响综合ICU血管导管相关血流感染发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5511>=55&&reportData.CONTENT5510>reportData.tablep5511Data[0].P25&&reportData.CONTENT5510<=reportData.tablep5511Data[0].P50)||(reportData.CONTENT5511<55&&reportData.CONTENT5510<reportData.CONTENT5512)'>
          <div class="" > ①本院综合ICU血管导管相关血流感染发病率与同级别、同类型、同规模医院比较，在较低发病率水平。 </div>
          <div class="" > ②关注影响综合ICU血管导管相关血流感染发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5511>=55&&reportData.CONTENT5510<=reportData.tablep5511Data[0].P25'>
          <div class="" > ①本院综合ICU血管导管相关血流感染发病率低于75%的同级别、同类型、同规模医院。 </div>
          <div class="" > ②关注影响综合ICU血管导管相关血流感染发病率的危险因素，并持续改进。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.5.2'>5.5.2 综合ICU呼吸机相关肺炎发病率</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5520!=null'>
        <div class="" > 
          本院综合ICU呼吸机相关肺炎发病率为：{{reportData.CONTENT5520}}‰
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模的医院数为{{reportData.CONTENT5521}}家，同期呼吸机使用总天数{{reportData.CONTENT5523}}，同期呼吸机相关肺炎感染例次数{{reportData.CONTENT5524}}，发病率{{reportData.CONTENT5522}}‰
          <div v-if='reportData.CONTENT5521>=55' style='display:inline;'>，其百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5521>=55'>
        <div class='surface-description'>表5-5-2 相同医院综合ICU呼吸机相关肺炎发病率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">呼吸机相关肺炎发病率百分位分布（‰）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5521Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5521Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5521Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5521>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5521>=55&&reportData.CONTENT5520>reportData.tablep5521Data[0].P75'>
          <div class="" > ①本院综合ICU呼吸机相关肺炎发病率高于75%的同级别、同类型、同规模医院。 </div>
          <div class="" > ②关注影响综合ICU呼吸机相关肺炎发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5521>=55&&reportData.CONTENT5520>reportData.tablep5521Data[0].P50&&reportData.CONTENT5520<=reportData.tablep5521Data[0].P75)||(reportData.CONTENT5521<55&&reportData.CONTENT5520>=reportData.CONTENT5522)'>
          <div class="" > ①本院综合ICU呼吸机相关肺炎发病率与同级别、同类型、同规模医院比较，高于50%的医院，在较高发病率水平。 </div>
          <div class="" > ②关注影响综合ICU呼吸机相关肺炎发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5521>=55&&reportData.CONTENT5520>reportData.tablep5521Data[0].P25&&reportData.CONTENT5520<=reportData.tablep5521Data[0].P50)||(reportData.CONTENT5521<55&&reportData.CONTENT5520<reportData.CONTENT5522)'>
          <div class="" > ①本院综合ICU呼吸机相关肺炎发病率与同级别、同类型、同规模医院比较，在较低发病率水平。 </div>
          <div class="" > ②关注影响综合ICU呼吸机相关肺炎发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5521>=55&&reportData.CONTENT5520<=reportData.tablep5521Data[0].P25'>
          <div class="" > ①本院综合ICU呼吸机相关肺炎发病率低于75%的同级别、同类型、同规模医院。 </div>
          <div class="" > ②关注影响综合ICU呼吸机相关肺炎发病率的危险因素，并持续改进。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="bold" style='margin-top:10px;' id='hps-5.5.3'>5.5.3 综合ICU导尿管相关泌尿系感染发病率</div>
        <div class="dept-yet-box" v-if='reportData.CONTENT5530!=null'>
        <div class="" > 
          本院综合ICU导尿管相关泌尿系感染发病率为：{{reportData.CONTENT5530}}‰
        </div>
        <div class="" >
          全国参与本次活动的同级别、同类型、同规模的医院数为{{reportData.CONTENT5531}}家，同期导尿管使用总天数{{reportData.CONTENT5533}}，同期导尿管相关泌尿道感染例次数{{reportData.CONTENT5534}}，发病率{{reportData.CONTENT5532}}‰
          <div v-if='reportData.CONTENT5531>=55' style='display:inline;'>，其百分位分布如下：</div>
        </div>
        <div class="table-box" v-if='reportData.CONTENT5531>=55'>
        <div class='surface-description'>表5-5-3 相同医院导尿管相关泌尿系感染发病率</div>
        <table
          class="table"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th colspan="11">导尿管相关泌尿系感染发病率百分位分布（‰）</th>
            </tr>
            <tr>
              <th>P10</th>
              <th>P20</th>
              <th>P25</th>
              <th>P30</th>
              <th>P40</th>
              <th>P50</th>
              <th>P60</th>
              <th>P70</th>
              <th>P75</th>
              <th>P80</th>
              <th>P90</th>
            </tr>
          </thead>
          <template v-if="reportData.tablep5531Data.length>0">
            <tr
              v-for="(item,index) in reportData.tablep5531Data"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
              v-if='index == reportData.tablep5531Data.length-1'
            >
              <td>{{item.P10!=null?item.P10:'-'}}</td>
              <td>{{item.P20!=null?item.P20:'-'}}</td>
              <td>{{item.P25!=null?item.P25:'-'}}</td>
              <td>{{item.P30!=null?item.P30:'-'}}</td>
              <td>{{item.P40!=null?item.P40:'-'}}</td>
              <td>{{item.P50!=null?item.P50:'-'}}</td>
              <td>{{item.P60!=null?item.P60:'-'}}</td>
              <td>{{item.P70!=null?item.P70:'-'}}</td>
              <td>{{item.P75!=null?item.P75:'-'}}</td>
              <td>{{item.P80!=null?item.P80:'-'}}</td>
              <td>{{item.P90!=null?item.P90:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='11'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>
        <div class='surface-description' style='margin-top:0'>（注：相同医院代指“同级别、同类型、同规模”医院）</div>
        </div>
        <div class="manageTips-box" v-if='reportData.CONTENT5531>=5'>
        <div class="" style='margin-top:10px;'> 管理提示： </div>
        <div class="tipsBox" v-if='reportData.CONTENT5531>=55&&reportData.CONTENT5530>reportData.tablep5531Data[0].P75'>
          <div class="" > ①本院综合ICU导尿管相关泌尿系感染发病率高于75%的同级别、同类型、同规模医院。 </div>
          <div class="" > ②关注影响综合ICU导尿管相关泌尿系感染发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5531>=55&&reportData.CONTENT5530>reportData.tablep5531Data[0].P50&&reportData.CONTENT5530<=reportData.tablep5531Data[0].P75)||(reportData.CONTENT5531<55&&reportData.CONTENT5530>=reportData.CONTENT5532)'>
          <div class="" > ①本院综合ICU导尿管相关泌尿系感染发病率与同级别、同类型、同规模医院比较，高于50%的医院，在较高发病率水平。 </div>
          <div class="" > ②关注影响综合ICU导尿管相关泌尿系感染发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='(reportData.CONTENT5531>=55&&reportData.CONTENT5530>reportData.tablep5531Data[0].P25&&reportData.CONTENT5530<=reportData.tablep5531Data[0].P50)||(reportData.CONTENT5531<55&&reportData.CONTENT5530<reportData.CONTENT5532)'>
          <div class="" > ①本院综合ICU导尿管相关泌尿系感染发病率与同级别、同类型、同规模医院比较，在较低发病率水平。 </div>
          <div class="" > ②关注影响综合ICU导尿管相关泌尿系感染发病率的危险因素，并持续改进。 </div>
        </div>
        <div class="tipsBox" v-if='reportData.CONTENT5531>=55&&reportData.CONTENT5530<=reportData.tablep5531Data[0].P25'>
          <div class="" > ①综合ICU导尿管相关泌尿系感染发病率低于75%的同级别、同类型、同规模医院。 </div>
          <div class="" > ②关注影响综合ICU导尿管相关泌尿系感染发病率的危险因素，并持续改进。 </div>
        </div>
        </div>
        </div>
        <div v-else>未上报数据</div>

        <div class="" style='margin-top:20px;'>温馨提示：可登录感控工作间后台获取获取本院的详细学习及考试名单 </div>
        <div class="">1、后台地址：<span style='color:#26b4ff;text-decoration:underline;'>{{pcUrl}}</span> </div>
        <div class="">2、账号和密码：同登录感控工作间APP一致 </div>
        <div class="">3、获取权限：仅限感控科主任的账号才有权限可以获取名单 </div>
        <div class="">4、学习名单获取路径：学习考试→学习手册→本院参与的学习 </div>
        <div class="">5、考试名单获取路径：学习考试→考试管理→本院参与的考试 </div>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-fu1'>附1 手卫生知识学习任务清单</div>
        <table class="mergeRowTable mergeRowTableTwo mergeRowTableCenter" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th style='width:10%'>序号</th>
              <th style='width:20%'>情景</th>
              <th style='width:70%'>学习课时</th>
            </tr>
          </thead>
          <template v-if='reportData.tableFifteenData.length>0'>
            <tbody v-for="(item,index) in reportData.tableFifteenData" :key='index' :style="{'background-color':index%2==0?'#fff':'#f1eff1'}" >
              <tr v-if='item.dataInfo.length>0'>
                <td :rowspan='item.dataInfo.length' class='childRenItem' >{{item.TASK_ORDER!=null?item.TASK_ORDER:'-'}}</td>
                <td :rowspan='item.dataInfo.length' class='childRenItem' style='text-align:left;'>{{item.TASK_NAME!=null?item.TASK_NAME:'-'}}</td>
                <td class='childRenItem' style='text-align:left;'>{{item.dataInfo[0].BIZ_NAME!=null?item.dataInfo[0].BIZ_NAME:'-'}}</td>
              </tr>
              <tr v-for="(d,idx) in item.dataInfo" v-if='idx>0' :key='idx' >
                <td class='childRenItem' style='text-align:left;'>{{d.BIZ_NAME!=null?d.BIZ_NAME:'-'}}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody>
              <tr> <td colspan='3' style="width:100%;text-align:center;" >暂无数据</td>
              </tr>
            </tbody>
          </template>
        </table>
        <div class="twoLevel-title" style='margin-top:10px;' id='hps-fu2'>附2 考试试卷题目清单</div>
        <table class="table" border="0" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th style='width:10%'>序号</th>
              <th style='width:20%'>题型</th>
              <th style='width:70%'>题干</th>
            </tr>
          </thead>
          <template v-if='reportData.tableSixteenData.length>0'>
            <tr
              v-for="(item,index) in reportData.tableSixteenData"
              :key='index'
              :style="{'background-color':index%2!=0?'#f1eff1':''}"
            >
              <td>{{item.BIZ_ORDER!=null?item.BIZ_ORDER:'-'}}</td>
              <td>{{item.QST_TYPE_NAME!=null?item.QST_TYPE_NAME:'-'}}</td>
              <td style='text-align:left;'>{{item.BIZ_NAME!=null?item.BIZ_NAME:'-'}}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                colspan='3'
                style="width:100%;"
              >暂无数据</td>
            </tr>
          </template>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hospitalStatistics',
    props: ['reportData'],
    data() {
      return {
        source: '',
        pcUrl:'https://dygk.gkgzj.com/incontrol-manager/account/toLoginIndex',
        echartsChildData: {},
      }
    },
    created() {
      this.source = this.$route.query.source
      this.initEcharts()
      this.$emit('sendEchartsImg', this.echartsChildData)
    },
    methods: {
      initEcharts() {
        this.$nextTick(() => {
          if (this.reportData.echartsOneData.length > 0 && this.reportData.contentObj.CONTENT9) {
            this.drawEcharts1('echarts1', this.reportData.echartsOneData)
          }
          if (this.reportData.echartsTwoData.length > 0 && this.reportData.contentObj.CONTENT14) {
            this.drawEcharts2('echarts2', this.reportData.echartsTwoData)
          }
          if (this.reportData.echartsTwo2Data.length > 0 && this.reportData.CONTENT27) {
            this.drawEcharts2('echarts2_6', this.reportData.echartsTwo2Data)
          }
          if (this.reportData.echartsThreeData.length > 0) {
            this.drawEcharts2('echarts3', this.reportData.echartsThreeData)
          }
          if (this.reportData.echartsFourData.length > 0) {
            this.drawEcharts3('echarts4', this.reportData.echartsFourData)
          }
          if (this.reportData.echartsFiveData.length > 0) {
            this.drawEcharts4('echarts5', this.reportData.echartsFiveData)
          }
        })
      },
      // dataURL 转 Blob对象
      dataURLtoBlob(dataurl) {
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1]
        // console.log(arr, mime);
        let bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], { type: mime })
      },
      drawEcharts1(id) {
        if (this.reportData.echartsOneData.length > 0) {
          let pieOneData = []
          let scoreName = []
          this.reportData.echartsOneData.map((item,index) => {
            pieOneData.push({
              name: item.EXAM_SCORE,
              value: item.USER_NUM1==0?'':item.USER_NUM1, // 饼图去除为0数据
              value1: item.USER_RATE,
            })
            scoreName.push(item.EXAM_SCORE)
          })
          var option = {
            animation: false,
            tooltip: {
              trigger: 'item',
              formatter: function formatter(params) {
                return ( params.marker + ' ' + params.data.name + ' : ' + params.data.value1 + '%' )
              },
            },
            legend: {
              orient: 'horizontal',
              top: 5,
              textStyle: {
                fontSize: this.reportData.isWeb?20:12,
                color: '#444'
              },
              data: scoreName
            },
            color: ['#6073f5', '#ff9502', '#ff6890', '#01e1ce', '#94d808', '#BD1910'],
            series: [
              {
                name: '成绩分布情况',
                type: 'pie',
                radius: '60%',
                center: ['50%', '60%'],
                data: pieOneData,
                avoidLabelOverlap: true,
                // minAngle: 10, // 控制最小角度
                itemStyle: {
                  normal:{ 
                    label:{ 
                        show: true,
                        fontSize: this.reportData.isWeb?20:12,
                        formatter: '{b} \n {d}%' 
                    }, 
                    labelLine :{show:true} 
                  } 
                },
                label: {
                  fontSize: this.reportData.isWeb?20:12,
                  color: '#444',
                  position: 'outside'
                },
                labelLine: {
                  show: true,
                  length: 20,
                  length2: 20,
                },
              },
            ],
          }

          let myChart = this.$echarts.init(document.getElementById(id))
          myChart.setOption(option, true)
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl1 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl1 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl1
            )
          })
        }
      },
      drawEcharts2(id, data) {

        var yName = []
        var complianceRate = []
        var correctRate = []
        for (var i = data.length - 1; i >= 0; i--) {
          var item = data[i]
          if(id == 'echarts2' || id == 'echarts2_6'){
            if(i != data.length - 1){
              yName.push(item.INDICATION_NAME)
              complianceRate.push(item.YCL ? item.YCL : 0)
              correctRate.push(item.ZQL ? item.ZQL : 0)
            }
          }else{
            yName.push(item.WORK_NAME)
            complianceRate.push(item.YCL ? item.YCL : 0)
            correctRate.push(item.ZQL ? item.ZQL : 0)
          }
        }
        var option = {
          animation: false,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: function formatter(params) {
              var result = ''
              for (var i = 0; i < params.length; i++) {
                var item = params[i]
                result +=
                  item.marker +
                  ' ' +
                  item.seriesName +
                  ' : ' +
                  item.value +
                  '%</br>'
              }
              return result
            },
            extraCssText: 'z-index:999;', //设置层级
          },
          legend: {
            bottom: '15',
            textStyle: {
              fontSize: this.reportData.isWeb?20:12,
              color: '#444',
            },
            data: ['依从率', '正确率'],
          },
          grid: {
            top: this.reportData.isWeb?'30':'30',
            bottom: this.reportData.isWeb?'150':'80',
            left: this.reportData.isWeb?'150':'80',
            right: this.reportData.isWeb?'150':'60',
          },
          xAxis: {
            type: 'value',
            max: 100,
            axisLabel: {
              fontSize: this.reportData.isWeb?20:12,
              color: '#444',
            },
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            type: 'category',
            axisLabel: {
              fontSize: this.reportData.isWeb?20:12,
              interval: 0, // 横轴信息全部显示
              color: '#444',
              formatter: function formatter(value) {
                var ret = '' //拼接加\n返回的类目项
                var maxLength = 5 //每项显示文字个数
                var valLength = value.length //X轴类目项的文字个数
                var rowN = Math.ceil(valLength / maxLength) //类目项需要换行的行数
                if (rowN > 1) {
                  //如果类目项的文字大于3,
                  for (var i = 0; i < rowN; i++) {
                    var temp = '' //每次截取的字符串
                    var start = i * maxLength //开始截取的位置
                    var end = start + maxLength //结束截取的位置
                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    temp = value.substring(start, end) + '\n'
                    ret += temp //凭借最终的字符串
                  }
                  return ret
                } else {
                  return value
                }
              },
            },
            data: yName,
          },
          series: [
            {
              name: '依从率',
              type: 'bar',
              barMaxWidth: 30,
              data: complianceRate,
              barWidth: this.reportData.isWeb?25:10,
              itemStyle: {
                normal: {
                  color: '#6073F5',
                },
              },
              label: {
                normal: {
                  show: true,
                  position: 'right',
                  fontSize: this.reportData.isWeb?20:12,
                  color: '#444',
                  formatter: function formatter(params) {
                    return params.data + '%'
                  },
                },
              },
            },
            {
              name: '正确率',
              type: 'bar',
              barMaxWidth: 30,
              barWidth: this.reportData.isWeb?25:10,
              itemStyle: {
                normal: {
                  color: '#ff9502',
                },
              },
              data: correctRate,
              label: {
                normal: {
                  show: true,
                  position: 'right',
                  fontSize: this.reportData.isWeb?20:12,
                  color: '#444',
                  formatter: function formatter(params) {
                    return params.data + '%'
                  },
                },
              },
            },
          ],
        }
        let autoHeight = option.yAxis.data.length * 70
        if(autoHeight < 350){
          autoHeight = 350
        }
        if (id == 'echarts2' || id == 'echarts2_6') {
          document.getElementById(id).style.height = autoHeight + 'px'
        }
        var myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        if (id == 'echarts2') {
          this.$nextTick(() => {
            this.reportData.echarts2AutoHeight = autoHeight
            console.log(this.reportData.echarts2AutoHeight,'this.reportData.echarts2AutoHeight');
            this.echartsChildData.echartsUrl2 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl2 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl2
            )
          })
        }else if(id == 'echarts2_6'){
          this.$nextTick(() => {
            this.reportData.echarts2_6AutoHeight = autoHeight
            console.log(this.reportData.echarts2_6AutoHeight,'this.reportData.echarts2_6AutoHeight');
            this.echartsChildData.echartsUrl2_6 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl2_6 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl2_6
            )
          })
        } else {
          this.$nextTick(() => {
            this.echartsChildData.echartsUrl3 = myChart.getDataURL({
              pixelRatio: 1,
            })
            this.echartsChildData.echartsUrl3 = this.dataURLtoBlob(
              this.echartsChildData.echartsUrl3
            )
          })
        }
      },
      drawEcharts3(id, data) {
        var name = []
        var constituent = []
        for (var i = 0; i < data.length; i++) {
          var item = data[i]
          name.push(item.WORK_NAME ? item.WORK_NAME : null)
          constituent.push({
            value: item.WORK_RATE ? item.WORK_RATE : null,
            name: item.WORK_NAME ? item.WORK_NAME : null,
          })
        }
        var option = {
          animation: false,
          tooltip: {
            trigger: 'item',
            formatter: function formatter(params) {
              return (
                params.marker + ' ' + params.name + ' : ' + params.value + '%'
              )
            },
            extraCssText: 'z-index:999;', //设置层级
          },
          legend: {
            orient: 'horizontal',
            top: 20,
            bottom: 20,
            textStyle: {
              fontSize: this.reportData.isWeb?20:12,
              color: '#444',
            },
            data: name,
          },
          color: [
            '#6073f5',
            '#ff9502',
            '#ff6890',
            '#01e1ce',
            '#94d808',
            '#BD1910',
          ],
          series: [
            {
              type: 'pie',
              radius: '60%',
              center: ['50%', '60%'],
              data: constituent,
              label: {
                fontSize: this.reportData.isWeb?20:12,
                color: '#444',
                position: 'outside',
                formatter: function formatter(params) {
                  if (params.value > 0) {
                    return params.value + '%'
                  } else {
                    return ''
                  }
                },
              },
              labelLine: {
                show: true,
                length: 10,
                length2: 5,
              },
            },
          ],
        }
        var myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        this.$nextTick(() => {
          this.echartsChildData.echartsUrl4 = myChart.getDataURL({
            pixelRatio: 1,
          })
          this.echartsChildData.echartsUrl4 = this.dataURLtoBlob(
            this.echartsChildData.echartsUrl4
          )
        })
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      },
      drawEcharts4(id, data) {
        var name = []
        var constituent = []
        for (var i = 0; i < data.length; i++) {
          var item = data[i]
          name.push(item.TASK_TYPE ? item.TASK_TYPE : null)
          constituent.push({
            value: item.YCS_RATE ? item.YCS_RATE : null,
            name: item.TASK_TYPE ? item.TASK_TYPE : null,
          })
        }
        var option = {
          animation: false,
          tooltip: {
            trigger: 'item',
            formatter: function formatter(params) {
              return (
                params.marker + ' ' + params.name + ' : ' + params.value + '%'
              )
            },
            extraCssText: 'z-index:999;', //设置层级
          },
          legend: {
            orient: 'horizontal',
            top: 20,
            bottom: 20,
            textStyle: {
              fontSize: this.reportData.isWeb?20:12,
              color: '#444',
            },
            data: name,
          },
          color: [
            '#6073f5',
            '#ff9502',
            '#ff6890',
            '#01e1ce',
            '#94d808',
            '#BD1910',
          ],
          series: [
            {
              type: 'pie',
              radius: '60%',
              center: ['50%', '60%'],
              data: constituent,
              label: {
                fontSize: this.reportData.isWeb?20:12,
                color: '#444',
                position: 'outside',
                formatter: function formatter(params) {
                  if (params.value > 0) {
                    return params.value + '%'
                  } else {
                    return ''
                  }
                },
              },
              labelLine: {
                show: true,
                length: 10,
                length2: 5,
              },
            },
          ],
        }
        var myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        this.$nextTick(() => {
          this.echartsChildData.echartsUrl5 = myChart.getDataURL({
            pixelRatio: 1,
          })
          this.echartsChildData.echartsUrl5 = this.dataURLtoBlob(
            this.echartsChildData.echartsUrl5
          )
        })
        window.addEventListener('resize', function () {
          myChart.resize()
        })
      }
    },
  }
</script>
<style lang='scss' scoped>
  #echarts3 {
    max-width: 90vw;
    min-width: 90vw;
    max-height: 400px;
    min-height: 400px;
  }
  #echarts2,#echarts2_6 {
    min-width: 90vw;
    min-height: 400px;
  }
  #echarts1,
  #echarts4,
  #echarts5,
  #echarts6 {
    max-width: 90vw;
    min-width: 90vw;
    max-height: 300px;
    min-height: 300px;
  }

  .web-echarts-heightFixed {
    max-width: 800px!important;
    min-width: 800px!important;
    margin:0 auto;
  }

  @import './public.scss';
</style>
